import React from 'react'
import Navbar from '../components/navbar'
import ShapeTwo from '../components/shape-two'
import bg1 from '../assets/images/blog/nosotros.png'
import { Link } from 'react-router-dom'
import Footer from '../components/footer'
import TeamOne from '../components/team-one'
import Partner from '../components/partner'
import celtara2 from '../assets/images/blog/celtara2.png'
import MesonaryPortfolio from '../components/mesonary-portfolio'
import { LuCheckCircle } from 'react-icons/lu'


export default function PageAbout() {
  return (
    <>
     <Navbar/> 

    <section className="bg-half-170 bg-light d-table w-100" style={{backgroundImage:`url(${bg1})`, backgroundPosition:'center'}}>
      <div className="bg-overlay"></div>
      <div className="container">
          <div className="row mt-5 text-center align-items-center">
              <div className="col-sm-6">
                  <div className="text-sm-start">
                      <div className="page-next-level">
                          <h4 className="title text-light"> Nosotros</h4>
                          <p className="text-muted mb-0">Información acerca del CNRC de Sonora</p>                                        
                      </div>
                  </div>
              </div>

                <div className="col-sm-6 mt-4 mt-sm-0 pt-2 pt-sm-0">
                    <div className="page-next-level text-sm-end">
                        <ul className="page-next ps-0 mb-0">
                            <li className="list-inline-item"><Link to="/" className="fw-bold text-light">Inicio</Link></li>
                            <li className="list-inline-item"><span className="text-primary fw-bold">Nosotros</span>
                            </li>
                        </ul>
                    </div>
                </div>
              
          </div>
      </div> 
    </section>

    <ShapeTwo/>

    <section className="section"> 
      <div className="container">
          <div className="row align-items-center" style={{textAlign:'justify', padding:20}}>
              <div className="col-md-6">
                  <div className="position-relative">
                      <img src={celtara2} className="img-fluid" alt=""  style={{borderTopLeftRadius:'80px 80px', borderBottomRightRadius:'80px 80px'}} />
                     </div>
              </div>

              <div className="col-md-6 mt-4 pt-2 mt-sm-0 pt-sm-0">
                  <div className="section-title ms-md-4">
                      <h4 className="title mb-4 text-warning"> Objetivo</h4>
                      <p className="text-muted">El objetivo fundamental del Centro de Neuromodulación Rehabilitación Cognitiva de Sonora es mejorar la calidad de vida de los pacientes a través de la modulación precisa y eficaz de la actividad del sistema nervioso.</p>
                      <p className="text-muted">Esto se logra al desarrollar, investigar, fabricar y/o aplicar tecnologías y terapias avanzadas que abordan una amplia gama de condiciones neurológicas y psiquiátricas, así como el dolor crónico.</p>
                      <p className="text-muted para-desc">Objetivos clave:</p>
                      <ul className="list-inline mb-0">
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Investigación y Desarrollo </li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Experiencia Clinica y Acceso al Paciente </li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Calidad y Seguridad </li>
                          <li className="h6"><i className="mdi mdi-check-circle-outline text-primary h5 mb-0 me-2 align-middle"></i> Sostenibilidad y Crecimiento </li>
                      </ul>      
                   
                  </div>
              </div>
          </div>
      </div>

 
    </section>

    <section id="cause" style={{paddingBottom:'0px'}} >    
    
                 <div className="container mb-60">
                       <div className="row">
                           <div className="col-12 text-center">
                               <div className="section-title">                                         
                                     <Partner />
                               </div>
                           </div>
                       </div>
                    
                   </div>
    
              <div className="container mt-80 mb-60">
                   <div className="row">
                       <div className="col-12 text-center">
                           <div className="section-title">
                               <h4 className="title mb-4">Equipo de trabajo</h4>
                               <p className="text-muted mx-auto mb-0" style={{maxWidth:'800px', textAlign:'center'}} >En CNRC de Sonora, nuestro verdadero propósito es transformar la vida de las personas que sufren condiciones debilitantes, devolviéndoles la funcionalidad, el alivio del dolor y, en última instancia, una mejor calidad de vida a través de soluciones neurológicas avanzadas y personalizadas.</p>
                           </div>
                       </div>
                   </div>
                   <TeamOne />
               </div>
        </section>

         <section className="section" style={{paddingTop:'30px'}}>
              <div className="container">
               <div className="row">
                            <div className="col-12 text-center">
                                <div className="section-title">
                                    <h5 className="mb-5"> <LuCheckCircle /> Nuestras <span className='text-primary' style={{textDecoration:'underline'}}>instalaciones</span></h5>                            
                                </div>
                            </div>
                        </div>
                      <MesonaryPortfolio grid="col-lg-12" row="column-5"/>
                      
                 
              </div>
            </section>
  
    <Footer/>
    </>
  )
}
